import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSmallScreen from 'hooks/useSmallScreen';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import AppBar from 'housecall-ui/dist/DesignSystem/Navigation/TopNavigation/AppBar/AppBar';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import CloseIcon from 'housecall-ui/dist/IconsAndImages/Icons/Close';

import { closePayWall, PAY_WALL_CONFIRMATION_TEXT } from 'components/PayWall/Redux/Actions';
import { PayWallFullState } from 'components/PayWall/Redux/Reducer.type';

type Props = {
  children: React.ReactNode;
  titleAddon?: React.ReactNode;
  onClose?: () => void;
};

function useOnCloseMobileDialog() {
  const originalCurrentPlan = useSelector((state: PayWallFullState) => state.payWall.originalCurrentPlan);
  const dispatch = useDispatch();

  return () => {
    if (Number(originalCurrentPlan.rate_flat_monthly) < 1) {
      dispatch({ type: PAY_WALL_CONFIRMATION_TEXT, status: true });
    } else {
      dispatch(closePayWall());
    }
  };
}

const useAppBarStyles = makeStyles(() => ({
  root: {
    height: 'auto',
  },
  toolbarGutters: {
    paddingLeft: 16,
    paddingRight: 16,
  },
}));

export default function PayWallDialogTitle(props: Props): JSX.Element | null {
  const { children, onClose, titleAddon = null } = props;
  const classes = useAppBarStyles();
  const isMobile = useSelector((state: PayWallFullState) => state.mobile);
  const isSmallScreen = useSmallScreen();
  const closeMobileDialog = useOnCloseMobileDialog();

  if (isMobile) {
    return null;
  }

  if (isSmallScreen) {
    return (
      <AppBar position="sticky" classes={classes} color="primary">
        <Box display="flex" flexGrow="1" width={1} alignItems="center">
          <IconButton
            onClick={() => {
              closeMobileDialog();
              onClose?.();
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box ml={1} display="flex" justifyContent="space-between" alignItems="center" flexGrow="1">
            <Typography variant="h2">{children}</Typography>
            {titleAddon}
          </Box>
        </Box>
      </AppBar>
    );
  }

  return (
    <DialogTitle disableTypography>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h2">{children}</Typography>
        {titleAddon}
      </Box>
    </DialogTitle>
  );
}
